export const ProductListColConfig = [
  {
    name_of_db_column: 'productId',
    label_of_column: 'Product ID',
    order_of_column: 1,
  },
  {
    name_of_db_column: 'status',
    label_of_column: 'Status',
    order_of_column: 2,
  },
  {
    name_of_db_column: 'productName',
    label_of_column: 'Product Name',
    order_of_column: 3,
  },
  {
    name_of_db_column: 'displayNameEnglish',
    label_of_column: 'Display Name (English)',
    order_of_column: 4,
  },
  {
    name_of_db_column: 'subcategoryEnglish',
    label_of_column: 'Subcategory (English)',
    order_of_column: 5,
  },
  {
    name_of_db_column: 'sorting',
    label_of_column: 'Sorting',
    order_of_column: 6,
  },
  {
    name_of_db_column: 'showOnECommerce',
    label_of_column: 'Show on e-Commerce',
    order_of_column: 7,
  },
  {
    name_of_db_column: 'suggestedProductSellingPrice',
    label_of_column: 'Suggested Product Selling Price',
    order_of_column: 8,
  },
  {
    name_of_db_column: 'multipleSellingUnits',
    label_of_column: 'Multiple Selling Units',
    order_of_column: 9,
  },
]
